module.exports = __webpack_public_path__ + "img/digital03.77b9e73f.png";